import { db } from '@config/firebaseConfig';
import { doc, getDoc, updateDoc, arrayUnion, Timestamp } from "firebase/firestore";

const buildCommentPayload = (userId, commentData) => ({
    user_id: userId,
    user_name: commentData.name,
    avatar_url: commentData.avatar,
    comment: commentData.comment,
    stars_given: commentData.rating,
    created_at: Timestamp.now(),
});

/**
 * Adds a new user comment to a specific product document in Firestore.
 * Each userId may only have one comment per product.
 */
export const addCommentToProduct = async (productId, commentData) => {
    if (!productId) {
        throw new Error("productId es requerido para agregar un comentario");
    }

    const userId = commentData.userId;
    if (!userId) {
        throw new Error("userId es requerido para agregar un comentario");
    }

    const productRef = doc(db, "products", productId);
    const snap = await getDoc(productRef);
    const existing = snap.exists() ? snap.data().comments || [] : [];

    if (existing.some((c) => c.user_id === userId)) {
        throw new Error("Ya publicaste una opinión en este producto. Puedes editarla.");
    }

    try {
        await updateDoc(productRef, {
            comments: arrayUnion(buildCommentPayload(userId, commentData)),
        });

        return true;
    } catch (error) {
        throw error;
    }
};

/**
 * Updates an existing comment for the given userId on a product.
 */
export const updateCommentInProduct = async (productId, userId, commentData) => {
    if (!productId) {
        throw new Error("productId es requerido para actualizar un comentario");
    }

    if (!userId) {
        throw new Error("userId es requerido para actualizar un comentario");
    }

    const productRef = doc(db, "products", productId);
    const snap = await getDoc(productRef);

    if (!snap.exists()) {
        throw new Error("Producto no encontrado");
    }

    const existing = snap.data().comments || [];
    const hasComment = existing.some((c) => c.user_id === userId);

    if (!hasComment) {
        throw new Error("No se encontró tu comentario para editar");
    }

    const updatedComments = existing.map((c) =>
        c.user_id === userId
            ? {
                ...c,
                user_name: commentData.name,
                avatar_url: commentData.avatar,
                comment: commentData.comment,
                stars_given: commentData.rating,
                updated_at: Timestamp.now(),
            }
            : c
    );

    try {
        await updateDoc(productRef, { comments: updatedComments });
        return true;
    } catch (error) {
        throw error;
    }
};
